import { render, staticRenderFns } from "./detail-lock.vue?vue&type=template&id=2a310942&scoped=true&"
import script from "./detail-lock.vue?vue&type=script&lang=js&"
export * from "./detail-lock.vue?vue&type=script&lang=js&"
import style0 from "./detail-lock.vue?vue&type=style&index=0&id=2a310942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a310942",
  null
  
)

export default component.exports